import { effects } from 'redux-saga';
import API from '../../helpers/sagaApi/SagaApi';
import reducers from '../reducers';
import Actions, { SagaAuthReduxTypes } from './sagaAuthRedux';
import { AppReduxTypes } from '../app/appRedux';
import { getCurrentPath, searchInObjectArrayCaseInsentitive } from '../../helpers/utility';
import * as R from 'ramda';

export const currentOfficeFnc = (state) => state.SagaAuth.currentOffice;

export function* getJwtToken() {
    const loginResponse = yield effects.select((state: typeof reducers) => {
        return state.SagaAuth.loginResponse;
    });
    return loginResponse;
}

/**
 * Validate the jwt token by trying to retrieve the user's profile
 * @returns {IterableIterator<any>}
 */
export function* validateJwtToken(jwtToken: string) {
    const userProfile = yield requestUserProfile(jwtToken);
    if (userProfile) {
        return true;
    } else {
        console.warn('[validateJwtToken] Token validation failed, logging out the user..');
        yield effects.put(Actions.requestLogout());
        return false;
    }
}


export function* getBranchId() {
    const loginResponse = yield effects.select((state: typeof reducers) => state.SagaAuth.currentOffice.id);
    return loginResponse;
}


export function* requestLogin(action) {
    const tag = '[REQUEST_LOGIN]';
    try {
        // step 1: perform input validation
        let currentOffice = yield effects.select(currentOfficeFnc);
        if(!currentOffice){
            // write function to retrive current office:
            // take a look at the url : /default/
            // look for office with name : 'default'

            currentOffice = yield requestOfficeList(null);
            // success -> validate
            // failure -> no need to validate, its already a fail
        }

        if(action.officeId && currentOffice && action.officeId !== currentOffice.id){
            
            // seems we are trying to login to a office that is not the same as existing office in redux ?
            currentOffice =  yield requestOfficeList(null);
        }

        const inputValid = action.username && action.password && currentOffice && currentOffice.id; // IDE-Help, do not delete me
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield effects.call(API.AccountLogin, action.username, action.password, currentOffice.id);
            if (response.status === 200 && response.data.statusCode === 200) {
                const token = response.data.result;
                const loginValid = yield validateJwtToken(token);
                if (loginValid) {
                    yield effects.put(Actions.loginSuccess(token));
                } else {
                    const userProfileError = yield effects.select((s: any) => s.SagaAuth.userProfileError);
                    throw new Error(userProfileError);
                }

            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('page.signInInvalidInput');
        }
    } catch (e) {
        console.warn(`${tag} requestLogin failed with error : ${e.message}`);
        const message = e.message
            ? e.message
            : 'Failed';
        yield effects.put(Actions.loginFailure(message));
    }

}

/**
 * 1. Requests office list from the server 
 * 2. Sets the current office based on the url ( eg: if url is like this http://localhost:3000/default/en/dashboard , office id will be set to office named "default" )
 * 3. Returns the current office
 * @param action 
 * @returns currentOffice object
 */
export function* requestOfficeList(action) {
    const tag = '[REQUEST_OFFICE_LIST]';
    try {
        const response = yield effects.call(API.OfficeList);
        if (response.status === 200 && response.data.statusCode === 200) {
            console.log(`${tag} requestOfficeList response :`, response.data);
            yield effects.put(Actions.officeListSuccess(response.data.result));
            const path = getCurrentPath();
            const officeFromUrl = R.split('/', path)[0];
            const currentOffice = searchInObjectArrayCaseInsentitive(response.data.result, 'officeName', officeFromUrl);
            const existingCurrentOffice = yield effects.select(currentOfficeFnc);
            // ***IF-EXISTING-OFFICE-ID NOT MATCH WITH OFFICE ID FROM URL, THEN REQUEST LOGOUT
            if((!existingCurrentOffice || existingCurrentOffice === undefined) || existingCurrentOffice.id !== currentOffice.id) {
                console.warn('REQUEST-LOGOUT DUE TO OFFICE-ID NOT MATCHED/CURRENT OFFICE-ID IS NULL');
                yield effects.put(Actions.requestLogout());
            }
            yield effects.put(Actions.setCurrentOffice(currentOffice));
            return currentOffice;
        } else {
            throw new Error(response.data.error);
        }

    } catch (e) {
        console.warn(`${tag} requestOfficeList failed with error :`, e);
        const message = e.message
            ? e.message
            : 'Failed';
        yield effects.put(Actions.officeListFailure(message));
    }
}

export function* requestUserProfile(jwtToken?: string) {
    const tag = '[REQUEST_USER_PROFILE]';
    try {
        // step 1: perform input validation
        const token = jwtToken ? jwtToken : yield getJwtToken(); // IDE-Help, do not delete me
        if (token) {
            // step 2 : validation passed..
            const response = yield effects.call(API.GetUserProfile, token);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUserProfile response :`, response.data);
                yield effects.put(Actions.userProfileSuccess(response.data.result));
                return response.data.result;
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('login.invalidToken');
        }
    } catch (e) {
        console.warn(`${tag} requestUserProfile failed with error :`, e);
        const message = e.message
            ? e.message
            : 'Failed';
        yield effects.put(Actions.userProfileFailure(message));
    }
}

export default function* rootSaga() {
    yield effects.all([
        effects.takeLatest(AppReduxTypes.STARTUP, requestOfficeList),
        effects.takeLatest(SagaAuthReduxTypes.REQUEST_LOGIN, requestLogin),
        effects.takeLatest(SagaAuthReduxTypes.REQUEST_OFFICE_LIST, requestOfficeList),
        effects.takeLatest(SagaAuthReduxTypes.REQUEST_USER_PROFILE, requestUserProfile, undefined)
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaAuth/sagaAuthSaga.ts